<template>
  <div class="article-box">
    <h5 class="article_title">公司简介</h5>
    <hr>
    <div class="article_content" v-html="data">
    </div>
  </div>
</template>

<script>
    export default {
        name: "helpabout",
      data(){
          return{
            data:''
          }
      },
      methods:{
        getData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                'nozzle': 'protocol',
                'type': 7,
              }
            })  .then(res => {
              let resData = res.data;
            if (res.data.code == 1) {
              that.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
        }
      },
      mounted() {
        this.getData();
      }
    }
</script>

<style scoped>
  .article_title{
    font-size: 20px;
    font-weight: 500;
  }
  .article_content>>>img{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpabout.vue